import { mapState } from 'vuex'

export default {
	computed: mapState({
		// arrow functions can make the code very succinct!
		permissions: state => state.auth.userdata.acls,
		userdata: state => state.auth.userdata
	}),

	created() {
	},
	methods: {
		$showRoles() {
			// console.log(this.permissions.length);
		},
		$hasRole(name) {
			return this.permissions && this.permissions.includes(name)
		},
		$hasOneOfRoles(names) {
			for(let i in names) {
				if (this.permissions && this.permissions.includes(names[i])) return true;
			}
			return false;
		},
		$getUserData() {
			return {
				user_email: this.userdata.user_email,
				user_id: this.userdata.user_id,
				user_login: this.userdata.user_login,
				user_name: this.userdata.user_name
			}
		}
	
	}
}